import { proposalsApi } from 'app/src/services/welfareportal'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'
import { mockProposalsCategories, mockProposalsDocuments } from './mockproposals'

export const getProposalsCategories = http.get<object, DefaultBodyType, proposalsApi.ProposalsCategories>(
  `${apiBaseUrl}/proposals/categories`,
  async () => {
    return HttpResponse.json(mockProposalsCategories)
  },
)

export const getProposalsDocuments = http.get<object, DefaultBodyType, proposalsApi.DocumentPaginated>(
  `${apiBaseUrl}/proposals/documents`,
  async () => {
    return HttpResponse.json(mockProposalsDocuments)
  },
)

export const proposalsHandlers = [getProposalsCategories, getProposalsDocuments]
